<template>
  <base-form
    v-model="data"
    :options="options"
    :disabled="disabled"
    labelWidth="90px"
    @input="handleChange"
  ></base-form>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  import { calAmount } from '@/common/js/contract-cal';
  import { spliceMoreZero } from '@/common/js/util';
  import { getLocalDataProps } from '../js';
  export default {
    props: {
      exchangeRate: {
        type: [Number, String],
        default: '',
      },
      defaultData: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      lastestReceiveProductDay: {
        type: String,
        default: '',
      },
    },
    components: {
      baseForm,
    },
    data() {
      const amountProps = [
        'acceptanceDiscountUnitPrice',
        'deliveryUnitPrice',
        'loadingUnitPrice',
        'outInExpense',
        'storageExpense',
        'freightExpense',
      ];
      const localProps = getLocalDataProps(amountProps);
      return {
        data: {
          lastestDeliveryDate: '',
          ...localProps,
        },
        amountProps,
      };
    },
    computed: {
      options() {
        return [
          {
            type: 'input',
            label: this.$t('contractAgency.transportTab.startAddress'),
            prop: 'startAddress',
          },
          {
            type: 'input',
            label: this.$t('contractAgency.transportTab.destinationAddress'),
            prop: 'destinationAddress',
          },
          {
            type: 'input',
            label: this.$t('contractAgency.transportTab.shipAddress'),
            prop: 'transferPort',
          },
          {
            type: 'sixNumber',
            label: this.$t('contractAgency.transportTab.freightExpense'),
            prop: 'freightExpense',
            moreInput: true,
            moreProp: 'freightExpenseLocal',
            moreDisabled: true,
            precision: 2,
          },
          {
            type: 'sixNumber',
            label: this.$t('contractAgency.transportTab.storageExpense'),
            prop: 'storageExpense',
            moreInput: true,
            moreProp: 'storageExpenseLocal',
            moreDisabled: true,
            precision: 2,
          },
          {
            type: 'sixNumber',
            label: this.$t('contractAgency.transportTab.outInExpense'),
            prop: 'outInExpense',
            moreInput: true,
            moreProp: 'outInExpenseLocal',
            moreDisabled: true,
            precision: 2,
          },
          {
            type: 'sixNumber',
            label: this.$t('contractAgency.transportTab.loadingUnitPrice'),
            prop: 'loadingUnitPrice',
            moreInput: true,
            moreProp: 'loadingUnitPriceLocal',
            moreDisabled: true,
            precision: 2,
          },
          {
            type: 'sixNumber',
            label: this.$t('contractAgency.transportTab.deliveryUnitPrice'),
            prop: 'deliveryUnitPrice',
            moreInput: true,
            moreProp: 'deliveryUnitPriceLocal',
            moreDisabled: true,
            precision: 2,
          },
          {
            type: 'sixNumber',
            label: this.$t('contractAgency.transportTab.acceptanceDiscountUnitPrice'),
            prop: 'acceptanceDiscountUnitPrice',
            moreInput: true,
            moreProp: 'acceptanceDiscountUnitPriceLocal',
            moreDisabled: true,
            precision: 2,
          },
          {
            type: 'date',
            label: this.$t('contractAgency.transportTab.lastestShipmentDate'),
            prop: 'lastestShipmentDate',
          },
          {
            type: 'date',
            label: this.$t('contractAgency.transportTab.lastestDeliveryDate'),
            prop: 'lastestDeliveryDate',
            disabled: true,
          },
          {
            type: 'date',
            label: this.$t('contractAgency.transportTab.actualShipmentDate'),
            prop: 'actualShipmentDate',
          },
          {
            type: 'textarea',
            label: this.$t('contractAgency.transportTab.otherExpenseComment'),
            prop: 'otherExpenseComment',
            span: 24,
            maxlength: 256,
          },
          {
            type: 'textarea',
            label: this.$t('contractAgency.transportTab.shipmentCondition'),
            prop: 'shipmentCondition',
            span: 24,
            maxlength: 256,
          },
        ];
      },
    },
    watch: {
      exchangeRate() {
        this.updateAmount();
      },
      defaultData() {
        const amountData = {};
        this.amountProps.forEach((prop) => {
          if (this.defaultData[prop]) {
            amountData[prop] = spliceMoreZero(this.defaultData[prop]);
            amountData[prop + 'Local'] = spliceMoreZero(this.defaultData[prop + 'Local']);
          }
        });
        const data = Object.assign({}, this.data, this.defaultData, amountData);
        this.data = data;
      },
      lastestReceiveProductDay() {
        this.data.lastestDeliveryDate = this.lastestReceiveProductDay;
      },
    },
    methods: {
      getValues() {
        const data = this.data;
        const result = Object.assign({}, data);
        if (!result.lastestDeliveryDate) delete result.lastestDeliveryDate;
        this.amountProps.forEach((prop) => {
          if (!result[prop]) {
            result[prop] = 0;
          }
        });
        return result;
      },
      // 表单变化
      handleChange(value, prop) {
        const index = this.amountProps.indexOf(prop);
        if (index > -1 && this.exchangeRate) {
          // 需要计算本币
          calAmount(this.data[prop], this.exchangeRate).then((showLocal) => {
            this.data[prop + 'Local'] = showLocal;
          });
        }
      },
      // 更新本币计算
      updateAmount() {
        Object.keys(this.data).forEach((prop) => {
          if (this.amountProps.indexOf(prop) > -1 && this.data[prop]) {
            calAmount(this.data[prop], this.exchangeRate).then((showLocal) => {
              this.data[prop + 'Local'] = showLocal;
            });
          }
        });
      },
    },
  };
</script>
